import React from 'react';

import { FormControl, FormHelperText } from 'material-ui/Form';
import { InputLabel } from 'material-ui/Input';
import Select from 'material-ui/Select';

const errorText = {
    display: 'flex',
    justifyContent: 'center',
    color: 'red'
};

const renderSelectField = ({ input, name, label, className, divClassName, onChange, meta: { touched, error }, children, ...custom }) => (

    <FormControl className={divClassName}>
        <InputLabel htmlFor={name} style={(touched && error && error !== '') ? { color: 'red' } : { color: '#BCBCBC' }}>{label}</InputLabel>
        <Select
            error={(touched && error && error !== '')}
            {...input}
            className={className}
            children={children}
            {...custom}
        />
        {
            touched && error &&
            <FormHelperText style={errorText}>{error}</FormHelperText>
        }
    </FormControl>
);

export default renderSelectField;


// WEBPACK FOOTER //
// ./src/helpers/RenderSelectField.js